"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import CustomScroll from "react-custom-scroll"
// import styles from './scroll.module.scss'
var ArcScroll = function ArcScroll(_ref) {
  var className = _ref.className,
    children = _ref.children,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
  // <CustomScroll heightRelativeToParent={height} className={className}>
  //     {children}
  // </CustomScroll>
  ;
};
var _default = ArcScroll;
exports["default"] = _default;